import { formatDateEuropean } from '@/shared/formatters/date';

export const formatarHoraCurta = (iso: string): string =>
  new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

// A thread cobre semanas: só a hora não diz de que dia é a mensagem. A lista segue com a hora, que
// é o que cabe na linha do preview.
export const formatarDataHora = (iso: string): string =>
  `${formatDateEuropean(iso)} ${formatarHoraCurta(iso)}`;
